/**
 * Per-device identity (§1). The seat choice is remembered per device but is
 * re-selectable on any device — there is no privileged "creator device".
 */
const seatKey = (coupleId: string) => `hyggebam.seat.${coupleId}`;

// ── Last-couple auto-login ───────────────────────────────────────────────────
const LAST_COUPLE_KEY = "hyggebam.lastCouple";

export function setLastCouple(token: string): void {
  localStorage.setItem(LAST_COUPLE_KEY, token);
}

export function getLastCouple(): string | null {
  return localStorage.getItem(LAST_COUPLE_KEY);
}

export function clearLastCouple(): void {
  localStorage.removeItem(LAST_COUPLE_KEY);
}

export function getSeat(coupleId: string): string | null {
  return localStorage.getItem(seatKey(coupleId));
}

export function setSeat(coupleId: string, personId: string): void {
  localStorage.setItem(seatKey(coupleId), personId);
}

export function clearSeat(coupleId: string): void {
  localStorage.removeItem(seatKey(coupleId));
}

// ── Post-watch feedback: remember the prompt was already shown for a chosen
// title, so a hard reload never re-hijacks the whole screen with it. ──────────
const feedbackSeenKey = (coupleId: string) => `hyggebam.feedbackSeen.${coupleId}`;

export function getFeedbackSeen(coupleId: string): number | null {
  const v = localStorage.getItem(feedbackSeenKey(coupleId));
  return v == null ? null : Number(v);
}

export function setFeedbackSeen(coupleId: string, tmdbId: number): void {
  localStorage.setItem(feedbackSeenKey(coupleId), String(tmdbId));
}

export function clearFeedbackSeen(coupleId: string): void {
  localStorage.removeItem(feedbackSeenKey(coupleId));
}

/** Read the capability token from the URL (/c/<token>). */
export function tokenFromPath(): string | null {
  const m = window.location.pathname.match(/^\/c\/([^/]+)/);
  return m ? m[1]! : null;
}

export function navigate(path: string): void {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
